/**
 * "Credit points after N orders" for normal users (never subscribed).
 *
 * Used by the Subscription Plan form, the only place it is configured. The number is how many orders the
 * customer completes BEFORE points start: 1 = after the first order, so repeat
 * orders earn; 0 = every order earns.
 */

export const NORMAL_USER_AFTER_PRESETS = [0, 1, 2, 3, 5];
export const NORMAL_USER_MAX_ORDERS_BEFORE = 100;

export const ordinal = (n) => {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  return `${n}${{ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th'}`;
};

/** Dropdown entry text. */
export const normalUserAfterLabel = (n) =>
  n === 0 ? 'No wait (from the first order)' : `${ordinal(n)} order`;

/** Short form for a notice: "every order" / "after 2nd order". */
export const normalUserAfterSummary = (n) => (Number(n) === 0 ? 'every order' : `after ${ordinal(Number(n))} order`);

/** Line under the dropdown spelling out which orders earn. */
export const normalUserAfterHelp = (value) => {
  const n = Number(value);
  if (!Number.isInteger(n) || n < 0) return 'Enter a whole number of orders.';
  if (n === 0) return 'Every paid order earns, starting with the first.';
  if (n === 1) return 'The first order earns nothing. Every repeat order earns, from order #2.';
  return `Orders #1–#${n} earn nothing. Points start on order #${n + 1}. Skipped orders are not credited later.`;
};

/** Which dropdown entry a stored number belongs to. */
export const normalUserAfterChoice = (value) => {
  const n = Number(value ?? 1);
  return NORMAL_USER_AFTER_PRESETS.includes(n) ? String(n) : 'custom';
};
